/* Houtensnijplankenmetlogo: levertijd, sticky knoppen, datum, samenvatting, chatknop in de ontwerptool en Trustpilot onder de kopregel */
(function () {
  'use strict';

  /* Chatknop (Shopify Inbox, <shopify-chat>) in de ontwerptool van Zakeke (/apps/zakeke) op mobiel
     rechtsboven zetten, waar geen knoppen van de ontwerptool zitten. Op desktop blijft hij staan. */
  (function chatPosition() {
    if (!/^\/apps\/zakeke/i.test(location.pathname)) return;
    var st = document.createElement('style');
    st.textContent = '@media (max-width: 989px){shopify-chat::part(activator){position:fixed!important;top:12px!important;right:12px!important;bottom:auto!important;left:auto!important}}';
    (document.head || document.documentElement).appendChild(st);
  })();

  /* Trustpilot-widget krijgt van Trustpilot zelf z-index 1000 (inline, !important) en schoof daardoor over
     de vaste kopregel (z-index 3). De omhullende div wordt een eigen laag onder de kopregel. */
  (function trustpilotLayer() {
    var st = document.createElement('style');
    st.textContent = '[id^="trustpilot-widget-trustbox"][id$="-wrapper"]{position:relative!important;z-index:2!important;isolation:isolate}';
    (document.head || document.documentElement).appendChild(st);
  })();

  var DAYS = ['zondag', 'maandag', 'dinsdag', 'woensdag', 'donderdag', 'vrijdag', 'zaterdag'];

  function nlNow() {
    var p = {};
    new Intl.DateTimeFormat('en-GB', {
      timeZone: 'Europe/Amsterdam', weekday: 'short', day: 'numeric', month: 'numeric',
      year: 'numeric', hour: '2-digit', minute: '2-digit', hour12: false
    }).formatToParts(new Date()).forEach(function (x) { p[x.type] = x.value; });
    return {
      wd: { Sun: 0, Mon: 1, Tue: 2, Wed: 3, Thu: 4, Fri: 5, Sat: 6 }[p.weekday],
      min: (parseInt(p.hour, 10) % 24) * 60 + parseInt(p.minute, 10),
      y: +p.year, m: +p.month, d: +p.day
    };
  }

  /* Levertijd. data-hs-eta="delivery" geeft "morgen in huis" of een dag,
     data-hs-eta="ship" geeft "vandaag verzonden" of een terugvaltekst. */
  function eta() {
    var els = document.querySelectorAll('[data-hs-eta]');
    if (!els.length || !window.Intl) return;
    try {
      var n = nlNow();
      els.forEach(function (el) {
        var cutoff = parseInt(el.getAttribute('data-cutoff') || '12', 10) * 60;
        var mode = el.getAttribute('data-hs-eta');
        var workday = n.wd >= 1 && n.wd <= 5;
        if (mode === 'ship') {
          el.textContent = workday && n.min < cutoff
            ? 'Voor ' + (cutoff / 60) + ':00 besteld, vandaag verzonden'
            : (el.getAttribute('data-fallback') || el.textContent);
          return;
        }
        var ship;
        if (n.wd === 6) ship = 2;
        else if (n.wd === 0) ship = 1;
        else if (n.min < cutoff) ship = 0;
        else ship = n.wd === 5 ? 3 : 1;
        var del = ship + 1;
        if ((n.wd + del) % 7 === 0) del += 1;
        var when = del === 1 ? 'morgen in huis' : DAYS[(n.wd + del) % 7] + ' in huis';
        var target = el.querySelector('[data-hs-eta-when]') || el;
        target.textContent = when;
        var lead = el.querySelector('[data-hs-eta-lead]');
        if (lead) lead.textContent = ship === 0 ? 'Voor ' + (cutoff / 60) + ':00 besteld,' : 'Nu besteld,';
      });
    } catch (e) {}
  }

  /* Datum van morgen, voor de bedankpagina (offertes ook in het weekend) */
  function tomorrow() {
    var els = document.querySelectorAll('[data-hs-tomorrow]');
    if (!els.length || !window.Intl) return;
    try {
      var n = nlNow();
      var dt = new Date(Date.UTC(n.y, n.m - 1, n.d + 1, 12));
      var label = dt.toLocaleDateString('nl-NL', { weekday: 'long', day: 'numeric', month: 'long', timeZone: 'UTC' });
      els.forEach(function (el) {
        var f = el.getAttribute('data-hs-tomorrow') || '{datum}';
        el.textContent = f.replace('{datum}', label);
      });
    } catch (e) {}
  }

  /* Sticky knop: zichtbaar zodra [data-hs-sticky-hide-when-gone] uit beeld is,
     en verborgen zolang [data-hs-sticky-hide-when-visible] in beeld is. */
  function sticky() {
    var bar = document.querySelector('[data-hs-sticky]');
    if (!bar || !('IntersectionObserver' in window)) return;
    /* Maar een keer koppelen per balk. In de themabewerker draait init() bij elke sectiewijziging opnieuw,
       en dan kreeg dezelfde balk steeds extra klikfuncties. */
    if (bar.getAttribute('data-hs-bound') === '1') return;
    bar.setAttribute('data-hs-bound', '1');
    function q(sel) { try { return sel ? document.querySelector(sel) : null; } catch (e) { return null; } }
    var anchor = q(bar.getAttribute('data-anchor'));
    var hideOn = q(bar.getAttribute('data-hide-on'));
    var gone = false, hideVisible = false;
    function update() {
      var on = gone && !hideVisible;
      bar.classList.toggle('is-visible', on);
      bar.setAttribute('aria-hidden', String(!on));
      bar.querySelectorAll('a, button').forEach(function (a) { a.tabIndex = on ? 0 : -1; });
    }
    if (anchor) {
      new IntersectionObserver(function (e) {
        gone = !e[0].isIntersecting && e[0].boundingClientRect.top < 0; update();
      }).observe(anchor);
    }
    if (hideOn) {
      new IntersectionObserver(function (e) { hideVisible = e[0].isIntersecting; update(); }).observe(hideOn);
    }
    bar.querySelectorAll('[data-hs-scroll-to]').forEach(function (btn) {
      btn.addEventListener('click', function (ev) {
        var t = q(btn.getAttribute('data-hs-scroll-to'));
        if (!t) return;
        ev.preventDefault();
        /* Open de ontwerptool direct als er een knop in het doel staat (Zakeke), anders scrollen */
        var clickable = t.matches('button, a') ? t : t.querySelector('button:not([disabled]), a[href]');
        if (clickable && (btn.hasAttribute('data-hs-click') || t.classList.contains('hs-app-block') || (t.id || '').indexOf('ProductSubmitButton') === 0)) { clickable.click(); return; }
        t.scrollIntoView({ behavior: 'smooth', block: 'center' });
        if (clickable) setTimeout(function () { clickable.focus({ preventScroll: true }); }, 400);
      });
    });
    update();
  }

  /* Samenvatting op de bedankpagina, als een formulier 'b2b_aanvraag' in sessionStorage zette */
  function summary() {
    var box = document.querySelector('[data-hs-summary]');
    if (!box) return;
    try {
      var raw = sessionStorage.getItem('b2b_aanvraag');
      if (!raw) return;
      var d = JSON.parse(raw);
      sessionStorage.removeItem('b2b_aanvraag');
      var rows = [];
      if (d.bedrijf) rows.push(['Bedrijf', d.bedrijf]);
      if (d.product) rows.push(['Plank', d.product]);
      if (d.aantal) rows.push(['Aantal', d.aantal]);
      if (d.leverdatum) rows.push(['Leverdatum', new Date(d.leverdatum).toLocaleDateString('nl-NL', { day: 'numeric', month: 'long', year: 'numeric' })]);
      if (d.logo_naam) rows.push(['Logo', d.logo_naam]);
      if (!rows.length) return;
      var dl = box.querySelector('dl');
      rows.forEach(function (r) {
        var dt = document.createElement('dt'); dt.textContent = r[0];
        var dd = document.createElement('dd'); dd.textContent = r[1];
        dl.appendChild(dt); dl.appendChild(dd);
      });
      box.hidden = false;
    } catch (e) {}
  }

  function init() { eta(); tomorrow(); sticky(); summary(); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
  document.addEventListener('shopify:section:load', init);
})();